import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const CustomAlert = ({ message, onClose }) => {
  const getAlertContent = () => {
    if (message.includes("Invalid email or password")) {
      return { emoji: "🔒", displayMessage: "Invalid email or password" };
    } else if (message.includes("Inactive user")) {
      return {
        emoji: "🚫",
        displayMessage: "Inactive user. Please contact admin.",
      };
    } else if (message.includes("Your account is under verification process")) {
      return {
        emoji: "⏳",
        displayMessage: "Your account is under verification process",
      };
    }
    return { emoji: "⚠️", displayMessage: message };
  };

  const { emoji, displayMessage } = getAlertContent();

  return (
    <div className="custom-alert">
      <span className="alert-icon">{emoji}</span>
      <span className="alert-message">{displayMessage}</span>
      <FontAwesomeIcon
        icon={faTimes}
        className="close-icon"
        onClick={onClose}
      />
    </div>
  );
};

export default CustomAlert;
